<main>

  <div class="mx-4 mb-10">
    <h3 class="text-4xl font-bold mb-2">Feedbacks</h3>
    <p class="text-sm">Faça a gestão das mensagens de contactos/feedback enviadas para a plataforma</p>
  </div>

  <!-- content wrapper -->
  <div class="bg-white p-5 border border-round">

    <!-- filtros aqui -->
    <div class="my-5">
      <app-feedback-filters (submitFilter)="onFilterSubmit($event)"></app-feedback-filters>
    </div>


    <div>
      <p-table [value]="feedbackList" styleClass="text-xs" [tableStyle]="{ 'min-width': '50rem' }">
        <ng-template pTemplate="header">
          <tr>
            <th>Nome</th>
            <th>Email</th>
            <th>Motivo</th>
            <th>Título</th>
            <th>Data de Envio</th>
            <th>Açcões</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-feedback>

          <tr>
            <td>{{ feedback.name | titlecase }}</td>
            <td>{{ feedback.email }}</td>
            <td>{{ feedback.type.description | titlecase }}</td>
            <td>{{ feedback.title }}</td>
            <td>{{ feedback.creationDate | date:'yyyy-MM-dd' }}</td>
            <td><i (click)="selectObjectForDropDown(feedback) ; setMouseEvent($event)"
            class="btn pi pi-cog cursor-pointer"></i></td>
          </tr>
        </ng-template>
      </p-table>

      @if (!tableHasData) {
        <p class="flex justify-center text-sm text-gray-500 font-medium my-10">Nenhuma mensagem foi
        encontrada, por favor verifique os filtros</p>
      }
    </div>

    @if (pagination) {
      <app-paginator [paginationDetails]="pagination"
        (pageChangeEvent)="onPageChange($event)"
      ></app-paginator>
    }
  </div>

</main>


<app-feedback-drop-down
  (onTerminateFeedbackSuccess)="onTerminateFeedback($event)"
  [feedback]="selectedObject" [clickEvent]="mouseEvent">
</app-feedback-drop-down>
